import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';


@Component({
    selector: 'app-addcase-menu',
    templateUrl: './addcase-menu.component.html',
    standalone: false
})
export class AddcaseMenuComponent implements OnInit {
  @Input() problemMenu: any;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onMenuOneClick = new EventEmitter<string>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onMenuTwoClick = new EventEmitter<any>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onMenuThreeClick = new EventEmitter<string>();

  menuOneClicked: string;
  menuTwoClicked: string;
  menuThreeClicked: string;

  constructor() { }

  ngOnInit() {
  }

  menuOneClick(menuItem: any) {
    if (this.menuOneClicked === '' || this.menuOneClicked !== menuItem) {
      this.onMenuOneClick.emit(menuItem);
      this.menuOneClicked = menuItem;
    } else {
      this.onMenuOneClick.emit('');
      this.menuOneClicked = '';
    }
    this.menuTwoClicked = '';
    this.menuThreeClicked = '';
  }

  menuTwoClick(menuItem: any) {
    if (this.menuTwoClicked === '' || this.menuTwoClicked !== menuItem.item) {
      this.onMenuTwoClick.emit(menuItem);
      this.menuTwoClicked = menuItem.item;
    } else {
      this.onMenuTwoClick.emit('');
      this.menuTwoClicked = '';
    }
    this.menuThreeClicked = '';
  }

  menuThreeClick(menuItem: any) {
    this.onMenuThreeClick.emit(menuItem);
    this.menuThreeClicked = menuItem;
  }
}
